<div [class.h-100]="fullHeight">
  <div class="nv-card-body" [class.h-100]="fullHeight">
    <ng-content></ng-content>
  </div>
</div>
